export const styles = {
  tooltip: {
    '& .MuiTooltip-tooltip': {
      fontSize: '0.8rem',
    },
  },
};
